import styled from 'styled-components';
import { FuelToast } from '@frete.com/fuel-react';

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.km6};
  gap: ${({ theme }) => theme.spacing.km6};
`;

export const WrapperToast = styled(FuelToast)`
  position: fixed;
  left: ${({ theme }) => theme.spacing.km12};
  bottom: ${({ theme }) => theme.spacing.km12};
  @media screen and (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    left: 0;
    padding: ${({ theme }) => theme.spacing.km4};
  }
`;

export const WrapperTitle = styled.span`
  display: flex;
`;

export const WrapperDescription = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km3};
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: end;
  gap: ${({ theme }) => theme.spacing.km6};
`;
